import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

const LabelDirectorySelect = ({ value, labels, onChange, disabled }) => {
    return (
        <>
            <FormControl fullWidth disabled={disabled}>
                <InputLabel id="label-directory-select-label">Labeling Directory</InputLabel>
                <Select
                    labelId="label-directory-select-label"
                    value={value}
                    label="Labeling Directory"
                    variant="standard"
                    size="small"
                    onChange={(e) => onChange(e.target.value)}
                >
                    {labels.map((label) => (
                        <MenuItem key={label.path} value={label.path}>
                            {label.name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

        </>
    );
};

export default LabelDirectorySelect;
